"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIdentifierName = void 0;
/**
 * id可能有4种情况
 * @param id
 * @returns
 */
function getIdentifierName(id) {
    if (typeof id === 'function') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (typeof id.toLegacyString === 'function') {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return id.toLegacyString();
        }
        // id为Newable
        return id.name;
    }
    // id为string和symbol
    return String(id);
}
exports.getIdentifierName = getIdentifierName;
//# sourceMappingURL=service-identifier.js.map